// JD JS
// const $shop_money_format = shopSymbol + '{{amount}}';
// const $money_format = function(t,r){function e(t,r){return void 0===t?r:t}function a(t,r,a,o){if(r=e(r,2),a=e(a,","),o=e(o,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(r);let n=t.split(".");return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+a)+(n[1]?o+n[1]:"")}"string"==typeof t&&(t=t.replace(".",""));let o="",n=/\{\{\s*(\w+)\s*\}\}/,i=r||this.money_format;switch(i.match(n)[1]){case"amount":o=a(t,2);break;case"amount_no_decimals":o=a(t,0);break;case"amount_with_comma_separator":o=a(t,2,".",",");break;case"amount_with_space_separator":o=a(t,2," ",",");break;case"amount_with_period_and_space_separator":o=a(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":o=a(t,0,".",",");break;case"amount_no_decimals_with_space_separator":o=a(t,0,".","");break;case"amount_with_space_separator":o=a(t,2,",","");break;case"amount_with_apostrophe_separator":o=a(t,2,"'",".")}return i.replace(n,o)};


// Close button
document.addEventListener('DOMContentLoaded', function () {
  const closeWraps = document.querySelectorAll('.fcc_close_wrap');
  const productWraps = document.querySelectorAll('.fcc_product_wrap');
  const pack1Checkbox = document.getElementById('pack1');

  closeWraps.forEach(closeWrap => {
    closeWrap.addEventListener('click', function () {
      productWraps.forEach(wrap => {
        wrap.classList.remove('active');
        const overlayPopup = document.querySelector('.fc-overlay-popup');
        if (overlayPopup) {
          overlayPopup.classList.remove('active');
        }
      });
    });
  });
});

const shopSymbolEl = document.querySelector('.currency_symbol');
const shopSymbol = shopSymbolEl ? shopSymbolEl.getAttribute('data-currency') : '';

function getStorageKey(productId) {
  return "JD_custom_product_" + productId;
}

// --- Format price with shopSymbol ---
function formatPrice(value) {
  if (!value) return shopSymbol + " 0.00";
  const num = parseFloat(value) / 100; // Shopify prices are in paise
  if (isNaN(num)) return shopSymbol + " 0.00";
  return shopSymbol + " " + num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

// --- Sync stored products with DOM prices ---
function syncStoredProducts(defaultProduct) {
  if (!defaultProduct) return;
  let stored = JSON.parse(localStorage.getItem(getStorageKey(defaultProduct.productId))) || [];
  if (!stored.length) return;

  stored = stored.map(item => {
    const domProduct = document.querySelector(`.fcc_product_item[data-product-id="${item.productId}"]`);
    if (domProduct) {
      item.productPrice = domProduct.getAttribute("data-price") || item.productPrice;
      item.productComPrice = domProduct.getAttribute("data-compare-price") || item.productComPrice;
    }
    return item;
  });

  localStorage.setItem(getStorageKey(defaultProduct.productId), JSON.stringify(stored));
}

document.addEventListener("DOMContentLoaded", function () {


  // --- Default Main Product ---
  const defaultProductEl = document.querySelector(".product-info__block-list");
  const defaultProduct = defaultProductEl ? (() => {
    const variantBtn = defaultProductEl.querySelector('input[name="id"]');
    return {
      productId: defaultProductEl.getAttribute("data-product-id") || "",
      productIMG: defaultProductEl.getAttribute("data-product-img") || "",
      productName: defaultProductEl.getAttribute("data-product-title") || "",
      productPrice: defaultProductEl.getAttribute("data-price") || "0",
      productComPrice: defaultProductEl.getAttribute("data-compare-price") || "0",
      variantId: variantBtn ? variantBtn.getAttribute("value") : "",
      isDefault: true
    };
  })() : null;

  if (!defaultProduct) return;

  syncStoredProducts(defaultProduct);

  const packRadios = document.querySelectorAll('input[name="pack"]');
  const packOneWrap = document.querySelector(".pack_one_wrap");
  const combo2 = document.querySelector(".fcc_combo_2pack_cover");
  const combo4 = document.querySelector(".fcc_combo_4pack_cover");
  const combo6 = document.querySelector(".fcc_combo_6pack_cover");
  const oneBuy = document.querySelector(".fcc_one_buy");
  const comboBuy = document.querySelector(".fcc_combo_buy");
  const comboCart = document.querySelector(".fcc_product_wrap");
  const comboCartBtn = document.querySelector(".fcc_buy_button.fcc_combo_cart");
  const colorInputs = document.querySelectorAll('.fcc_product_item input[name="colour"]');
  const buyButton = document.querySelector(".fcc_box_button .fcc_buy_button");

  const priceList = document.querySelector(".fcc_price_list");
  const priceBundle = document.querySelector(".fcc_price_list_bundle");

  // --- Update pack view ---
  function updateView() {
    const selected = document.querySelector('input[name="pack"]:checked')?.value;
    if (!selected) return;
    [packOneWrap, combo2, combo4, combo6, oneBuy, comboBuy].forEach(el => el && (el.style.display = "none"));

    const discountEls = document.querySelectorAll(".fcc_combo_discount .discount_price");

    if (selected === "1-pack") {
      packOneWrap && (packOneWrap.style.display = "block");
      oneBuy && (oneBuy.style.display = "block");
      comboCart?.classList.remove("active");

      priceList?.style.setProperty("display", "flex");
      priceBundle?.style.setProperty("display", "none");
      discountEls.forEach(el => (el.textContent = ""));

    } else if (["2-pack", "4-pack", "6-pack"].includes(selected)) {
    const cover =
        selected === "2-pack" ? combo2 :
            selected === "4-pack" ? combo4 :
                combo6;
    cover && (cover.style.display = "block");
    comboBuy && (comboBuy.style.display = "block");

    let stored = JSON.parse(localStorage.getItem(getStorageKey(defaultProduct.productId))) || [];
    if (defaultProduct && !stored.find(p => p.productId === defaultProduct.productId)) {
        stored.unshift({ ...defaultProduct });
        localStorage.setItem(getStorageKey(defaultProduct.productId), JSON.stringify(stored));
    }

    renderPackItems(selected === "2-pack" ? 2 : selected === "4-pack" ? 4 : 6);
    
    // Price display is now handled in renderPackItems based on stored.length
}


    updateQuantityLimits();
  }

  packRadios.forEach(radio => radio.addEventListener("change", updateView));
  updateView();

  // --- Update active product/color ---
  function updateActiveState(input) {
    document.querySelectorAll('.fcc_product_item').forEach(i => i.classList.remove("active"));
    document.querySelectorAll('.fcc_variant-quantity').forEach(b => b.classList.remove("active"));
    const parentItem = input.closest(".fcc_product_item");
    parentItem && parentItem.classList.add("active");
    const targetBlock = document.querySelector(`#variant-block-${input.value}`);
    targetBlock && targetBlock.classList.add("active");
  }

  colorInputs.forEach(input =>
    input.addEventListener("change", () => input.checked && updateActiveState(input))
  );
  if (colorInputs[0]) {
    colorInputs[0].checked = true;
    updateActiveState(colorInputs[0]);
  }

  // --- Buy Button → add selected product to localStorage ---
  buyButton?.addEventListener("click", function () {
    const activeProduct = document.querySelector(".fcc_product_item.active");
    const activeVariant = document.querySelector('.fcc_variant-quantity.active .opation-color button[aria-selected="true"]');
    const qtyInput = document.querySelector('.fcc_variant-quantity.active .quantity-selector__input');
    if (!activeProduct || !activeVariant || !qtyInput) return;

    const productData = {
      productId: activeProduct.getAttribute("data-product-id"),
      productIMG: activeProduct.getAttribute("data-product-img"),
      productName: activeProduct.getAttribute("data-product-title"),
      productPrice: activeProduct.getAttribute("data-price"),
      productComPrice: activeProduct.getAttribute("data-compare-price"),
      variantId: activeVariant.getAttribute("data-variant-id")
    };

    const quantity = parseInt(qtyInput.value) || 1;
    let stored = JSON.parse(localStorage.getItem(getStorageKey(defaultProduct.productId))) || [];

    const selected = document.querySelector('input[name="pack"]:checked')?.value;
    const limit =
      selected === "2-pack" ? 2 :
        selected === "4-pack" ? 4 :
          selected === "6-pack" ? 6 : 1;


    const availableSlots = limit - stored.length;
    const addCount = Math.min(quantity, availableSlots);

    for (let i = 0; i < addCount; i++) stored.push({ ...productData, quantity: 1 });

    localStorage.setItem(getStorageKey(defaultProduct.productId), JSON.stringify(stored));

    if (selected === "4-pack") renderPackItems(4);
    if (selected === "6-pack") renderPackItems(6);
    if (selected === "2-pack") renderPackItems(2);

    comboCart?.classList.remove("active");
    updateQuantityLimits();
  });

  // document.querySelectorAll(".fcc_add_item").forEach(btn =>
  //   btn.addEventListener("click", () => comboCart && comboCart.classList.add("active"))
  // );

  document.querySelectorAll(".fcc_add_item").forEach(btn =>
    btn.addEventListener("click", () => {
      comboCart && comboCart.classList.add("active");
      const overlayPopup = document.querySelector('.fc-overlay-popup');
      if (overlayPopup) {
        overlayPopup.classList.add('active');
      }
    })
  );


  comboCartBtn?.addEventListener("click", async function () {
    const selected = document.querySelector('input[name="pack"]:checked')?.value;
    if (!selected) return;

    const limit =
      selected === "2-pack" ? 2 :
        selected === "4-pack" ? 4 :
          selected === "6-pack" ? 6 : 1;

    let stored = JSON.parse(localStorage.getItem(getStorageKey(defaultProduct.productId))) || [];
    if (stored.length < limit) return alert(`Please select ${limit} products first.`);

    const itemsToAdd = stored.map(p => ({ id: p.variantId, quantity: 1 }));

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: itemsToAdd })
      });
      if (response.ok) {
        await response.json();
        window?.opusRefreshCart?.();
        window?.opusOpen?.();
        // Reset stored products with default product
        localStorage.setItem(getStorageKey(defaultProduct.productId), defaultProduct ? JSON.stringify([defaultProduct]) : "[]");
        comboCart?.classList.remove("active");
        comboCartBtn.classList.add("disabled");
        comboCartBtn.setAttribute("disabled", "true");
        renderPackItems(limit);
        updateQuantityLimits();
      } else {
        const err = await response.json();
        alert("Error adding to cart: " + err.description);
      }
    } catch (e) {
      console.error("Add to cart failed:", e);
    }
  });

  // --- Render Pack Items ---
  function renderPackItems(limit) {
    let stored = JSON.parse(localStorage.getItem(getStorageKey(defaultProduct.productId))) || [];
    if (stored.length > limit) stored = stored.slice(0, limit);

    const cover =
      limit === 2 ? combo2 :
        limit === 4 ? combo4 :
          combo6;

    if (!cover) return;

    const items = cover.querySelectorAll(".fcc_item_set");

    items.forEach(el => {
      const addedDiv = el.querySelector(".fcc_added_item");
      if (addedDiv) addedDiv.remove();
    });

    stored.forEach((product, index) => {
      if (!items[index]) return;
      const el = items[index];

      const div = document.createElement("div");
      div.className = "fcc_added_item";
      div.setAttribute("data-variant-id", product.variantId);

      // ✅ Always show remove button, including default product
      div.innerHTML = `
      <button class="remove_item">&times;</button>
      <div>
        <div class="media"><img src="${product.productIMG}" alt="${product.productName}" /></div>
        <p class="fcc_add_title">${product.productName}</p>
      </div>
    `;
      el.appendChild(div);

      div.querySelector(".remove_item").addEventListener("click", function () {
        stored = stored.filter((p, i) => i !== index);
        localStorage.setItem(getStorageKey(defaultProduct.productId), JSON.stringify(stored));
        renderPackItems(limit);
        updateQuantityLimits();
      });
    });

    // Update remaining count and discount text
const remaining = limit - stored.length;
const counterSpan = comboCartBtn?.querySelector(".fcc_disabled span");

// Determine free items based on pack
const freeItems = limit === 2 ? 1 : limit === 4 ? 2 : 3;

// Update discount text for all packs
const discount2Text = document.querySelector(".fcc_combo_2_pack_discont_text");
const discount4Text = document.querySelector(".fcc_combo_4_pack_discont_text");
const discount6Text = document.querySelector(".fcc_combo_6_pack_discont_text");

// Helper function to replace numbers in text
function updateDiscountText(element, remaining, freeItems, limit) {
    if (!element) return;
    
    const defaultText = element.getAttribute("data-discount-text") || "";
    const successText = element.getAttribute("data-discount-success") || "";
    
    if (remaining > 0) {
        // Replace number in the text (finds first number and replaces with remaining)
        const updatedText = defaultText.replace(/\d+/, remaining);
        element.textContent = updatedText;
    } else {
        element.textContent = successText;
    }
}

if (limit === 2) updateDiscountText(discount2Text, remaining, freeItems, limit);
if (limit === 4) updateDiscountText(discount4Text, remaining, freeItems, limit);
if (limit === 6) updateDiscountText(discount6Text, remaining, freeItems, limit);

if (remaining > 0) {
    if (counterSpan) counterSpan.textContent = remaining;
    comboCartBtn?.classList.add("disabled");
    comboCartBtn?.setAttribute("disabled", "true");
} else {
    if (counterSpan) counterSpan.textContent = "0";
    comboCartBtn?.classList.remove("disabled");
    comboCartBtn?.removeAttribute("disabled");
}

    // --- Discount Calculation (Buy X + Get X Free) ---
    const paidCount =
      limit === 2 ? 1 :
        limit === 4 ? 2 :
          limit === 6 ? 3 :
            limit;

    let totalPrice = 0;
    let totalComparePrice = 0;

    stored.forEach((product, index) => {
      const price = parseFloat((product.productPrice || "0").replace(/,/g, ""));
      totalComparePrice += price;
      if (index < paidCount) totalPrice += price;
    });

    const discountPrice = totalComparePrice - totalPrice;

    const mainPriceEl = priceBundle?.querySelector(".main_price");
    const comparePriceEl = priceBundle?.querySelector(".compare_price");
    const discountEls = document.querySelectorAll(".fcc_combo_discount .discount_price");

    if (mainPriceEl) mainPriceEl.textContent = formatPrice(totalPrice);
    if (comparePriceEl) comparePriceEl.textContent = formatPrice(totalComparePrice);
    discountEls.forEach(el => el.textContent = formatPrice(discountPrice));

    // Show fcc_price_list only when exactly 1 item selected, otherwise show fcc_price_list_bundle
    if (stored.length === 1) {
      priceList?.style.setProperty("display", "flex");
      priceBundle?.style.setProperty("display", "none");
    } else {
      priceList?.style.setProperty("display", "none");
      priceBundle?.style.setProperty("display", "flex");
    }

    localStorage.setItem(getStorageKey(defaultProduct.productId), JSON.stringify(stored));
  }

  // --- Quantity Limit System ---
  function updateQuantityLimits() {
    const selected = document.querySelector('input[name="pack"]:checked')?.value;
    const limit =
      selected === "2-pack" ? 2 :
        selected === "4-pack" ? 4 :
          selected === "6-pack" ? 6 : 1;


    let stored = JSON.parse(localStorage.getItem(getStorageKey(defaultProduct.productId))) || [];
    const remaining = limit - stored.length;

    const qtyInputs = document.querySelectorAll('.fcc_variant-quantity .quantity-selector__input');

    qtyInputs.forEach((input) => {
      if (limit === 1) {
        input.max = 1;
        input.value = Math.min(input.value, 1);
      } else {
        input.max = remaining > 0 ? remaining : 1;
        if (parseInt(input.value) > input.max) input.value = input.max;
      }
    });
  }

  updateQuantityLimits();

  // Stoq App Notify button
  const notifyButton = document.querySelector('.fcc_get_notified');
  if (notifyButton) {
    notifyButton.addEventListener('click', function (event) {
      event.preventDefault();
      const restockButton = document.querySelector('.restock-rocket-button-cover');
      if (restockButton) {
        restockButton.click(); // Programmatically trigger the click event
      }
    });
  }

});
